<template>
  <div class="root">
    <div class="hh-register-container margin-top-50">
      <div class="panel panel-default">
        <div class="container-fluid">
          <div v-if="isLoading" class="section-body margin-top-50 margin-bottom-50">
              <LoadingAnimation :show-message="true"/>
          </div>
          <div class="section section-body" v-show="!isLoading">
            <div class="row margin-top-20">
              <div class="col-sm-12 form margin-bottom-30 form">
                <Step1
                  v-if="step === 1"
                  @formSubmitted="formSubmitted"
                  @componentLoading="componentLoading"
                  :userData="userData.dataStep1"
                  :staticData="staticData"
                  :userRoles="userRoles"
                  :identities="identities"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Step1 from "./steps/Step-1";
import LoadingAnimation from "../../components/LoadingAnimation";
import { scrollTop } from "../../utils/componentHelper";

export default {
  name: "Form",

  components: {
    Step1,
    LoadingAnimation,
  },

  props: {},

  data: () => {
    return {
      step: 1,
      loading: true,
      dataAnalysed: false,
      config: {},
      componentsLoadingStatus: {
        stepComponent: true,
      },
      userData: {
        verified: false,
        roles: null,
        dataStep1: {},
        dataStep4: {},
      },
      userRoles: null,
      identities: null,
      staticData: {},
    };
  },

  beforeMount() {
    if (_.isEmpty(this.registerData)) {
      this.$store.dispatch("fetchRegisterData").then(() => {
        this.dataAnalysed = false;
        this.loading = true;
        this.analyseUserData();
      });
    } else {
      this.dataAnalysed = false;
      this.loading = true;
      this.analyseUserData();
    }
  },

  mounted() {
    this.loading = true;
  },

  methods: {
    fillUserData() {
      this.step = this.registerData.data.attributes.step + 1;
      this.userData.verified = this.registerData.data.attributes.verified;
      this.userRoles = this.registerData.data.attributes.roles;
      this.identities = this.registerData.data.attributes.identities;

      this.fillDataStep1();
      this.fillDataStep4();
    },
    fillDataStep1() {
      this.userData.dataStep1.email = this.registerData.data.attributes.email;
      this.userData.dataStep1.first_name =
        this.registerData.data.attributes.first_name;
      this.userData.dataStep1.last_name =
        this.registerData.data.attributes.last_name;
    },

    fillDataStep4() {
      if (!_.isEmpty(this.registerData.data.relations.payoutInformation)) {
        let accountData =
          this.registerData.data.relations.payoutInformation.data.attributes;
        this.userData.dataStep4 = { ...accountData };
      }
      this.userData.dataStep4.business_name =
        this.registerData.data.attributes.business_name;
    },

    fillConfigData() {
      if (!_.isEmpty(this.registerData.config)) {
        this.config = this.registerData.config;
      }
    },

    fillStaticData() {
      if (!_.isEmpty(this.registerData.data.staticData)) {
        this.staticData = {
          ...this.staticData,
          ...this.registerData.data.staticData,
        };
      }
    },

    analyseUserData() {
      if (!_.isEmpty(this.registerData)) {
        this.fillUserData();
        this.fillConfigData();
        this.fillStaticData();

        if (this.userData.verified !== true) {
          window.location = "/email/verify";
          return;
        }
      }

      if (
        _.isEmpty(this.userRoles) &&
        !_.isEmpty(localStorage.getItem("userType"))
      ) {
        this.userRoles = [localStorage.getItem("userType")];
      }

      this.dataAnalysed = true;
      this.loading = false;
    },

    navigateBack() {
      --this.step;
      scrollTop();
    },

    navigateNext() {
      ++this.step;
      scrollTop();
    },

    componentLoading(componentName, value) {
      this.componentsLoadingStatus[componentName] = value;
    },

    formSubmitted() {
      this.loading = true;
      this.$store.dispatch("fetchRegisterData").then(() => {
        this.dataAnalysed = false;
        this.analyseUserData();
      });
    },
  },

  computed: {
    ...mapGetters({
      registerData: "registerData",
      authUser: "authUser",
    }),

    isLoading() {
      for (let component in this.componentsLoadingStatus) {
        if (this.componentsLoadingStatus[component]) {
          return true;
        }
      }

      return this.loading;
    },
  },
};
</script>
<style lang="scss" scoped>
.root::v-deep {
  @import '../../../style/pages/register';
}
</style>
